import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../actions'

const defaultState = false

export default handleActions(
  {
    [rawActions.getIterationStatus.request](state, { payload }) {
      return true
    },
    [combineActions(rawActions.getIterationStatus.success, rawActions.getIterationStatus.failed)](state, { payload }) {
      return false
    },
  },
  defaultState
)
